export const STAY_PROFILE_TYPE = 'Stay & Hospitality' as const;

export const STAY_MONTHLY_PRODUCT_CODE = 'STAY-MONTHLY-01' as const;
export const STAY_ANNUAL_PRODUCT_CODE = 'STAY-ANNUAL-01' as const;
/** 30-day free trial — converts to STAY-MONTHLY-01 on day 31 via PayFast billing_date. */
export const STAY_TRIAL_PRODUCT_CODE = 'STAY-TRIAL-30' as const;

// ── Early Adopters Lifetime Promo ──────────────────────────────────────────
// Existing subscribers keep legacy rates while active. Cancel/default → going rate.
// LEGACY (going) prices — DO NOT DELETE:
export const STAY_MONTHLY_PRICE_LEGACY = 1000 as const;
export const STAY_ANNUAL_PRICE_LEGACY = 10000 as const;

// ── Current (going-rate) prices — effective now ──────────────────────────
export const STAY_MONTHLY_PRICE = 500 as const;
export const STAY_ANNUAL_PRICE = 5000 as const;

/** Apps unlocked for Stay & Hospitality subscribers */
export const STAY_PLAN_ALLOWED_APPS: string[] = [];

export const isStayProfileType = (value: unknown): boolean =>
  String(value || '').trim().toLowerCase() === STAY_PROFILE_TYPE.toLowerCase();

export const isStayProductCode = (value: unknown): boolean => {
  const code = String(value || '').trim();
  return (
    code === STAY_MONTHLY_PRODUCT_CODE ||
    code === STAY_ANNUAL_PRODUCT_CODE ||
    code === STAY_TRIAL_PRODUCT_CODE
  );
};
